import * as React from 'react'

import { Text, TextName } from 'sdk/text/Text'

import { HomeTechnologyBenefitsCmsContent } from 'core/services/cms/interfaces'

import { TechBenefitsCard } from '../../components/tech-benefits-card/TechBenefitsCard'
import ArrowIcon from '../../components/tech-benefits-card/assets/arrow.svg'

import styles from './style.module.scss'

interface TechBenefitsSectionProps {
  content: HomeTechnologyBenefitsCmsContent
}

const renderResponsiveCardTitle = (title: string): React.ReactNode => {
  const lines = title.split('\n')

  return lines.map((line, index) => (
    <React.Fragment key={`${line}-${index}`}>
      {index > 0 ? <span className={styles.titleBreak} /> : null}
      <span>{line}</span>
      {index < lines.length - 1 ? ' ' : null}
    </React.Fragment>
  ))
}

export const TechBenefitsSection: React.FC<TechBenefitsSectionProps> = ({ content }) => {
  return (
    <div className={styles.section}>
      <div className={styles.header}>
        <Text type={TextName.H2}>{content.title}</Text>
        <Text type={TextName.Text}>{content.description}</Text>
      </div>

      <div className={styles.cards}>
        {content.cards.map((card) => (
          <TechBenefitsCard
            key={card.title}
            title={renderResponsiveCardTitle(card.title)}
            body={card.body}
            iconSrc={ArrowIcon}
          />
        ))}
      </div>
    </div>
  )
}
